import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M2.43457 2.55469C2.02036 2.55469 1.68457 2.89047 1.68457 3.30469V18.9569C1.68457 20.3316 2.79899 21.446 4.1737 21.446H19.8259C21.2006 21.446 22.315 20.3316 22.315 18.9569V6.78295C22.315 6.36873 21.9792 6.03295 21.565 6.03295H12.3748L9.99109 2.85469C9.84945 2.66583 9.62716 2.55469 9.39109 2.55469H2.43457ZM3.18457 18.9569V4.05469H9.01609L11.3998 7.23295C11.5414 7.4218 11.7637 7.53295 11.9998 7.53295H20.815V18.9569C20.815 19.5031 20.3722 19.946 19.8259 19.946H4.1737C3.62742 19.946 3.18457 19.5031 3.18457 18.9569ZM11.9998 10.3809C12.414 10.3809 12.7498 10.7166 12.7498 11.1309V12.9897H14.6085C15.0227 12.9897 15.3585 13.3255 15.3585 13.7397C15.3585 14.154 15.0227 14.4897 14.6085 14.4897H12.7498V16.3483C12.7498 16.7625 12.414 17.0983 11.9998 17.0983C11.5856 17.0983 11.2498 16.7625 11.2498 16.3483V14.4897H9.3911C8.97688 14.4897 8.6411 14.154 8.6411 13.7397C8.6411 13.3255 8.97688 12.9897 9.3911 12.9897H11.2498V11.1309C11.2498 10.7166 11.5856 10.3809 11.9998 10.3809Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const AddItemOutlined = React.forwardRef(IconComponent);
AddItemOutlined.displayName = 'AddItemOutlined';

export { AddItemOutlined };
